import script from "./TheIntegrations.vue?vue&type=script&setup=true&lang=js"
export * from "./TheIntegrations.vue?vue&type=script&setup=true&lang=js"

import "./TheIntegrations.vue?vue&type=style&index=0&id=4770139b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4770139b"]])

export default __exports__